import { StudentDebtType } from "../../../types/Finance";
import { StudentType } from "../../../types/Student";
import { TokenResponseType } from "../../../types/TokenResponse";
import { UserType } from "../../../types/User";

export const receiptPayload = (data: {
  studentDebt: StudentDebtType;
  student: StudentType;
  user: UserType;
  loggedUserData: TokenResponseType;
  IES: any;
  logoBase64?: string;
}) => {
  const { studentDebt, student, user, loggedUserData, IES, logoBase64 } = data;
  return {
    type: "RECEIPT",
    outputformat: "DOCX",
    data: {
      ies: IES?.NAME ?? "",
      endereco: IES?.COUNTRY ?? "",
      nuit: IES?.NUIT ?? "",
      unidade: IES?.ENROLLMENT_DEPARTAMENT_NAME ?? "",
      telefone: IES?.PHONE_NUMBER ?? "",
      email: IES?.EMAIL ?? "",
      servico: studentDebt.paymentType ?? "N/D",
      utilizador: loggedUserData?.Fullname ?? "N/D",
      semestre: student?.semester ?? "N/D",
      nr_factura: studentDebt. code?? "N/D",
      data: new Date().toLocaleDateString(),
      total: studentDebt.originalAmount.toFixed(2),
      nome_est: student?.fullname ?? "N/D",
      nr_est: user?.phoneNumber,
      nuit_est: user?.nuit ?? "N/D",
      endereco_est: "N/D",
      email_est: user?.email ?? "N/D",
      codigo: student.schoolCode ?? "N/D",
      data_pagamento: new Date().toLocaleDateString(),
      descricao_final: studentDebt.description ?? "N/D",
      tabela: [
        {
          Num_Operacao: "1",
          tabela_descricao: studentDebt.paymentType ?? "N/D",
          valor: studentDebt.originalAmount.toFixed(2),
          moeda: "MNZ",
        },
      ],
    },
    logoBase64: logoBase64 ?? "",
  };
};
